
import React, { Component } from 'react'
import PIMAgov from '../assets/pima-logo.png'

export default class PimaTopBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      counter: 0,
    };
  }

  handleOpenNav = () => {
    if (this.state.counter % 2 >= 1) {
      this.setState({ open: !this.state.open })
    } else {
      this.setState({ open: !this.state.open })
      this.setState({ counter: this.state.counter + 1 })
    }
  }

  render() {
    return (
      <div>
        <div className="pimaTopBarContainer">
          <div className="pimaLogoContainer">
            <img src={PIMAgov} alt="PIMA logo" />
          </div>
          <nav>
            <ul>
              <li >
                <a href="https://webcms.pima.gov/government/geographic_information_systems/gis_maps/" target="_blank" rel="noopener noreferrer">GIS</a>
              </li>
              <li>
                <a href="https://webcms.pima.gov/recreation/maps/" target="_blank" rel="noopener noreferrer">RECREATION</a>
              </li>
              <li>
                <a href="https://webcms.pima.gov/health/health_maps/" target="_blank" rel="noopener noreferrer">HEALTH</a>
              </li>
              <li>
                <a href="">DEVELOPMENT</a>
              </li>
              <li>
                <a href="">BUSINESS</a>
              </li>
              <li>
                <a href="https://webcms.pima.gov/community/maps/" target="_blank" rel="noopener noreferrer">COMMUNITY</a>
              </li>
              <li>
                <a href="">ENVIRONMENT</a>
              </li>
            </ul>
          </nav>
        </div>

        <div className="topMobileNav">
          <div className="burgerContainer">
            <img src={PIMAgov} alt="pima logo" />
            <div className="burgerIcon" onClick={this.handleOpenNav}>
              <button>
                <span className="burgerRow"></span>
                <span className="burgerRow"></span>
                <span className="burgerRow"></span>
              </button>
            </div>
          </div>
          {this.state.open ?
            <div className="mobileNavContent">
              <nav>
                <ul>
                  <li >
                    <a href="https://webcms.pima.gov/government/geographic_information_systems/gis_maps/" target="_blank" rel="noopener noreferrer">GIS</a>
                  </li>
                  <li>
                    <a href="https://webcms.pima.gov/recreation/maps/" target="_blank" rel="noopener noreferrer">RECREATION</a>
                  </li>
                  <li>
                    <a href="https://webcms.pima.gov/health/health_maps/" target="_blank" rel="noopener noreferrer">HEALTH</a>
                  </li>
                  <li>
                    <a href="">DEVELOPMENT</a>
                  </li>
                  <li>
                    <a href="">BUSINESS</a>
                  </li>
                  <li>
                    <a href="https://webcms.pima.gov/community/maps/" target="_blank" rel="noopener noreferrer">COMMUNITY</a>
                  </li>
                  <li>
                    <a href="">ENVIRONMENT</a>
                  </li>
                </ul>
              </nav>
            </div>
            : null
          }

        </div>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/components/PimaTopBar.js